import ConsentManager from '../ConsentManager';
import ModalLayer from '../ModalLayer';
import TemplateHandler from '../TemplateHandler';
import { getQueryParamsArray } from '../../tools/helpers';

class VideoTeaserLightbox {
  constructor(options = {}) {
    this.element = options.element;
    this.lightboxButton = this.element.querySelector('.lightbox-trigger');
    this.consentNeeded = true;
    this.videoId = this.element.dataset.videoId;
    this.consentContent = TemplateHandler.getTemplate('consent-overlay-content', this.element);
    this.lightboxContent = TemplateHandler.getTemplate('consent-given-content', this.element);
    this.isMuted = false;
  }

  init() {
    this.initLightbox();

    const queryVideo = getQueryParamsArray('video');

    if (queryVideo != null && queryVideo.length > 0 && this.element.dataset && this.element.dataset.headline &&
      this.element.dataset.headline === queryVideo[0]) {

      this.isMuted = true;
      this.openModal();
    }
  }

  initLightbox() {
    this.lightboxButton.addEventListener('click', (event) => {
      if (this.element.dataset.headline) {
        this.setVideoQueryParameter();
      }

      this.openModal();
      event.stopPropagation();
      event.preventDefault();
    });
    this.lightboxButton.addEventListener('keyup', (event) => {
      if (event.keyCode === 13) {
        if (this.element.dataset.headline) {
          this.setVideoQueryParameter();
        }

        this.openModal();
        event.stopPropagation();
        event.preventDefault();
      }
    });
  }

  openModal() {
    this.lightbox = new ModalLayer({
      element: this.element,
      content: document.querySelector(`[id="modal-layer-${this.videoId}"]`),
      insertedContentType: 'video',
    });
    this.initConsentManager();
    this.lightbox.bindEvents();
  }

  initConsentManager() {
    // console.log('Init COnsent Manaager in FUnction', this.consentNeeded);
    if (this.consentNeeded) {
      this.consentManager = new ConsentManager({
        element: this.element,
        consentTemplateId: this.element.querySelector('[data-template-name="consent-overlay-content"]').dataset.templateId,
        consentDataProcessor: this.element.querySelector('[data-template-name="consent-overlay-content"]').dataset.processor,
        callbackFail: () => this.insertConsent(),
        callbackSuccess: () => this.insertContent(),
        callbackReinit: () => this.init(),
      });

      this.consentManager.init();
      // this.checkForConsent();
    }
  }

  insertConsent() {
    const content = document.createElement('section');
    content.insertAdjacentHTML('beforeend', this.consentContent);
    this.lightbox.replaceContent(content);
    this.addLayerEvents();
    this.lightbox.showModal();
  }

  insertContent() {
    const content = document.createElement('section');
    content.insertAdjacentHTML('beforeend', this.lightboxContent);

    if (this.isMuted) {
      const iframeList = content.getElementsByTagName('iframe');
      if (iframeList.length > 0) {
        const iframeWithoutMuted = iframeList.item(0).src;

        if (iframeWithoutMuted.includes('muted=0')) {
          iframeList.item(0).src = iframeWithoutMuted.replace('muted=0', 'muted=1');
        } else {
          iframeList.item(0).src = `${iframeWithoutMuted}${iframeWithoutMuted.includes('?') ? '&' : '?'}muted=1`;
        }
      }

      const videoWithoutMuted = content.getElementsByTagName('video');
      if (videoWithoutMuted.length > 0) {
        videoWithoutMuted.item(0).muted = true;
      }
    }

    this.lightbox.replaceContent(content);
    this.lightbox.showModal();
  }

  addLayerEvents() {
    const buttonAccept = document.querySelector('body').querySelector(`[id="modal-layer-${this.videoId}"]`).querySelector('.give-consent');
    if (buttonAccept !== null) {
      buttonAccept.addEventListener('click', () => {
        this.consentManager.giveConsent();
      });
    }

    const buttonInfo = document.querySelector('body').querySelector(`[id="modal-layer-${this.videoId}"]`).querySelector('.more-info');
    if (buttonInfo !== null) {
      const templateId = this.element.querySelector('[data-template-name="consent-overlay-content"]').dataset.templateId;
      buttonInfo.addEventListener('click', () => {
        this.consentManager.toggleConsentWindow(templateId);
      });
    }
  }

  setVideoQueryParameter() {
    const searchParams = new URLSearchParams(window.location.search);

    searchParams.set('video', this.element.dataset.headline);

    if (searchParams.size > 0) {
      window.history.replaceState(null, null, `${window.location.pathname}?${searchParams.toString()}`);
    } else {
      window.history.replaceState(null, null, window.location.pathname);
    }
  }
}

export default VideoTeaserLightbox;
